
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  locale: string,
  password: string,
  ssr?: boolean
};

/**
 * Export `fetchELearningPage`.
 */

export async function fetchELearningPage({ locale, password, ssr }: Query) {
  const endpoint = getApiEndpoint('getELearningPage', { password });

  try {
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale)
    });

    return data?.data;
  } catch (error) {
    if (!ssr) {
      throw handleRequestError(error);
    }
  }
}
